module.exports = __webpack_public_path__ + "img/geod_17.2308d014.jpg";